// extracted by mini-css-extract-plugin
export default {"root":"LgFXzUK7332Nu0NSGUO7","description":"FS72Lr3vq3W6ez_2PEwg"};